import { MobileStickyNavbar } from "./core/mobile-nav";
import { DesktopNavbar } from "./core/desktop-nav";

const Navbar = () => (
  <>
    <MobileStickyNavbar />
    <DesktopNavbar />
  </>
);

export default Navbar;
